<div class="order-pricing">
	@for (annualPricing of pricing.annualPricings; track trackByAnnualPricingFcn(i, annualPricing); let i = $index) {
		<price-card [pricingYear]="i + 1" [annualPricing]="annualPricing"
					[feesByAuditType]="feesFor(annualPricing)" [includeOffsiteDays]="includeOffsiteDays"></price-card>
	}
</div>
